import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from '@itds/elements/index.js';
import FormUtils from '@itds/utils/Form';

import EditContactDrawer from './contacts/Edit';

const Contacts = ({ relationship, saveRelationship }) => {
  const [contact, setContact] = useState(null);

  const handleSave = contact => {
    const contacts = relationship.contacts.map(c => {
      if (c.id === contact.id) {
        return contact;
      }

      return c;
    });

    if (!contact.id) {
      contacts.push(contact);
    }

    setContact(null);
    saveRelationship({ vendor_contacts_attributes: contacts });
  };

  const handleDelete = (id, e) => {
    const contacts = relationship.contacts.map(c => {
      if (c.id === id) {
        c._destroy = true;
      }

      return c;
    });

    e.stopPropagation();

    saveRelationship({ vendor_contacts_attributes: contacts });
  };

  return (
    <>
      <EditContactDrawer
        contact={contact}
        onClose={setContact.bind(null, null)}
        onSave={handleSave}
        show={!!contact}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={setContact.bind(null, { id: null, name: '' })}>Add Contact</Button>
      </div>

      <Table
        columns={[
          {
            id: 'first_name',
            is_sortable: true,
            label: 'First Name'
          },
          {
            id: 'last_name',
            label: 'Last Name'
          },
          {
            id: 'email',
            label: 'Email'
          },
          {
            id: 'phone',
            label: 'Phone',
            render: c => FormUtils._formatAsPhone(c.phone)
          },
          {
            id: 'title',
            label: 'Title'
          },
          {
            id: 'actions',
            render: contact => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, contact.id)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={relationship.contacts}
        defaultSortColumn={{ id: 'first_name' }}
        onRowClick={setContact}
      />
    </>
  );
};

Contacts.propTypes = {
  relationship: PropTypes.object,
  saveRelationship: PropTypes.func
};

export default Contacts;
